const API_URL = 'https://api.kinomap.dev/v4/';
const OAUTH_URL = 'https://login.kinomap.dev/';
const WEBSITE = 'http://www.kinomap.dev';

export const environment = {
  gAnalyticsCode: 'G-L1G74ZFY8N',
  apiUrl: API_URL,
  oAuthUrl: OAUTH_URL,
  website: WEBSITE,
  creatorAppToken:
    'NcREBvqyI55j3py9oEN58bocnxsy5AsHC9b1vro3kjacyxbK1OF0PT00fip8GFF7EEYXWcO4lP6Hc7i1JLRntHdyOquiV0fou49e4O7et1LtZRkwt0JKvL89',
};
